import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const login = resolve => require(['../components/login'], resolve) // 登录
const layout = resolve => require(['../components/layout'], resolve) // 布局
const home = resolve => require(['../components/home/home'], resolve) // 工作台
const allBook = resolve => require(['../components/book/allBook'], resolve) // 全部书籍
const recoverBook = resolve => require(['../components/book/recoverBook'], resolve) // 回收书籍
const unrecoverBook = resolve => require(['../components/book/unrecoverBook'], resolve) // 不回收书籍
const unknowBook = resolve => require(['../components/book/unknowBook'], resolve) // 未知书籍
const order = resolve => require(['../components/order/order'], resolve) // 订单管理
const money = resolve => require(['../components/money/money'], resolve) // 资产管理
const user = resolve => require(['../components/user/user'], resolve) // 用户管理
const notice = resolve => require(['../components/system/notice'], resolve) // 公告设置
const recoverLimit = resolve => require(['../components/system/recoverLimit'], resolve) // 卖书限制
const store = resolve => require(['../components/system/store'], resolve) // 仓库设置
const school = resolve => require(['../components/system/school'], resolve) // 学校设置
const cashLimit = resolve => require(['../components/system/cashLimit'], resolve) // 提现限制
const shipping = resolve => require(['../components/system/shipping'], resolve) // 物流设置
const proxyUser = resolve => require(['../components/proxy/user'], resolve) // 代理用户
const proxyOrder = resolve => require(['../components/proxy/order'], resolve) // 代理订单

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/',
      name: 'work',
      component: layout,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      },
      children: [
        // 工作台
        {
          path: '/home',
          name:'home',
          component: home
        },
        // 全部书籍
        {
          path: 'allBook',
          name:'allBook',
          component: allBook
        },
        // 回收书籍
        {
          path: 'recoverBook',
          name:'recoverBook',
          component: recoverBook
        },
        // 不回收书籍
        {
          path: 'unrecoverBook',
          name:'unrecoverBook',
          component: unrecoverBook
        },
        // 未知书籍
        {
          path: 'unknowBook',
          name:'unknowBook',
          component: unknowBook
        },
        // 订单管理
        {
          path: 'order',
          name:'order',
          component: order
        },
        // 资产管理
        {
          path: 'money',
          name:'money',
          component: money
        },
        // 用户管理
        {
          path: 'user',
          name:'user',
          component: user
        },
        // 公告设置
        {
          path: 'notice',
          name:'notice',
          component: notice
        },
        // 卖书限制
        {
          path: 'recoverLimit',
          name:'recoverLimit',
          component: recoverLimit
        },
        // 仓库设置
        {
          path: 'store',
          name:'store',
          component: store
        },
        // 学校设置
        {
          path: 'school',
          name:'school',
          component: school
        },
        // 提现限制
        {
          path: 'cashLimit',
          name:'cashLimit',
          component: cashLimit
        },
        // 提现限制
        {
          path: 'shipping',
          name:'shipping',
          component: shipping
        },
        {
          path: 'proxyOrder',
          name:'proxyOrder',
          component: proxyOrder
        },
        {
          path: 'proxyUser',
          name:'proxyUser',
          component: proxyUser
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js